module.exports = __webpack_public_path__ + "static/img/BICGRAPHIC_logo_vert-01.0788115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BICGRAPHIC_logo_vert-01.png
// module id = 304
// module chunks = 2